import styled from '@emotion/styled';

export default styled('span')`
  font-size: 13px !important;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: -0.1px;
`;
